import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IMThumbnailCardStatus } from './typings';

@Component({
  selector: 'm-thumbnail-card',
  template: `
    <div class="m-thumbnail-card-container">
      <label class="m-thumbnail-card-checkbox" nz-checkbox [(ngModel)]="mChecked" (ngModelChange)="mCheckedChange.emit($event)"></label>
      <img class="m-thumbnail-card-img" [attr.src]="mSrc" alt="thumbnail" />
      <div
        class="m-thumbnail-card-status"
        [ngClass]="{
          'm-thumbnail-card-status-failed': mStatus === 'failed',
          'm-thumbnail-card-status-success': mStatus === 'success'
        }"
      >
        <ng-container [ngSwitch]="mStatus">
          <i nz-icon nzType="check-circle" *ngSwitchCase="'success'"></i>
          <i nz-icon nzType="close-circle" *ngSwitchCase="'failed'"></i>
        </ng-container>
        <span>{{ mDescription }}</span>
      </div>
      <div class="m-thumbnail-card-type">
        {{ mTitle }}
      </div>
      <div class="m-thumbnail-card-content">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class MThumbnailCardComponent {
  @Input() mSrc = '';
  @Input() mTitle = '';
  @Input() mChecked = false;
  @Input() mDescription = '未识别到表格';
  @Input() mStatus: IMThumbnailCardStatus = 'success';

  @Output() readonly mCheckedChange = new EventEmitter<boolean>();
}
